import { createSlice } from "@reduxjs/toolkit";
import { loadGitDiff } from "./thunks/loadGitDiff.thunk";
import { GitDiffsState } from "./types";

const initialState: GitDiffsState = {
  data: {}
};

const gitDiffs = createSlice({
  name: "gitDiffs",
  initialState,
  reducers: {},
  extraReducers: builder => {
    // LOAD GIT DIFF
    builder
      .addCase(loadGitDiff.pending, (state, action) => {
        const { left, right } = action.meta.arg;
        const key = `${left}:${right}`;
        state.data[key] = {
          ...state.data[key],
          error: undefined,
          isLoading: true
        };
      })
      .addCase(loadGitDiff.fulfilled, (state, action) => {
        const { left, right } = action.meta.arg;
        const key = `${left}:${right}`;
        state.data[key] = {
          ...state.data[key],
          isLoading: false,
          data: action.payload
        };
      })
      .addCase(loadGitDiff.rejected, (state, action) => {
        const { left, right } = action.meta.arg;
        const key = `${left}:${right}`;
        state.data[key] = {
          ...state.data[key],
          error: action.payload?.error,
          isLoading: false
        };
      });
  }
});

export default gitDiffs.reducer;
